import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth, AuthProvider } from "./context/AuthContext";
import LoginPage from "./components/LoginPage";
import DashboardLayout from "./components/DashboardLayout";
import SiteConfigPage from "./pages/SiteConfigPage";
import NewsPage from "./pages/NewsPage";
import EventsPage from "./pages/EventsPage";
import "./App.css";
import NovelSummary from "./pages/NovelSummary";
import Header from "./components/Header"; // Importing the Header component
import JambQuestionsPage from "./pages/JambQuestionsPage";
import SubjectsPage from "./pages/SubjectsPage";
import ProjectRequestsPage from "./pages/ProjectRequestsPage";
import AssignmentsPage from "./pages/AssignmentsPage";
import UsersPage from "./pages/UsersPage";
import UserIssuesPage from "./pages/UserIssuesPage";
import GeneralStudiesPage from "./pages/GeneralStudiesPage";
import AdminMessagesPage from "./pages/AdminMessagesPage";
import AdminRoute from "./components/AdminRoute";
import MailBroadcastPage from "./pages/MailBroadcastPage";
import WelcomeEmailPage from "./pages/WelcomeEmailPage";
import TeamExamSettingsPage from "./pages/TeamExamSettingsPage";

function ProtectedRoute({ children }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <Header /> {/* Adding the Header component */}
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/dashboard/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<SiteConfigPage />} />
          <Route path="site-config" element={<SiteConfigPage />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="edit-novel" element={<NovelSummary />} />
          <Route path="edit-jamb" element={<JambQuestionsPage />} />
          <Route path="subjects" element={<SubjectsPage />} />
          <Route path="project-requests" element={<ProjectRequestsPage />} />
          <Route path="assignment-requests" element={<AssignmentsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="user-issues" element={<UserIssuesPage />} />
          <Route path="general-studies" element={<GeneralStudiesPage />} />
          <Route path="admin-messages" element={<AdminMessagesPage />} />
          <Route path="send-mail" element={<AdminRoute><MailBroadcastPage /></AdminRoute>} />
          <Route path="welcome-email" element={<AdminRoute><WelcomeEmailPage /></AdminRoute>} />
          <Route path="team-exam" element={<AdminRoute><TeamExamSettingsPage /></AdminRoute>} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
